
<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container">
      <h1 class="title-main">{{'ProcessFruzty.ImporterSection.TitleMain' | translate}}</h1>
      <h2 class="subtitle-main">{{'ProcessFruzty.ImporterSection.SubtitleMain' | translate}}</h2>

      <div class="container-flex">
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ImporterSection.TitleStep1' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">01</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ImporterSection.TextStep1' | translate}}
            </p>
          </div>
        </section>
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/importer_step_1.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
      </div>

      <div class="container-flex flex-reverse">
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/importer_step_2.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ImporterSection.TitleStep2' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">02</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ImporterSection.TextStep2' | translate}}
            </p>
          </div>
        </section>
      </div>

      <div class="container-flex">
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ImporterSection.TitleStep3' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">03</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ImporterSection.TextStep3' | translate}}
            </p>
          </div>
        </section>
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/importer_step_3.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
      </div>

    </div>
  </div>

  <div class="divider">
  </div>

  <div class="bg-container">
    <div class="container">
      <h1 class="title-main">{{'ProcessFruzty.ExporterSection.TitleMain' | translate}}</h1>
      <h2 class="subtitle-main">{{'ProcessFruzty.ExporterSection.SubtitleMain' | translate}}</h2>

      <div class="container-flex">
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ExporterSection.TitleStep1' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">01</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ExporterSection.TextStep1' | translate}}
            </p>
          </div>
        </section>
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/exporter_step_1.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
      </div>

      <div class="container-flex flex-reverse">
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/exporter_step_2.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ExporterSection.TitleStep2' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">02</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ExporterSection.TextStep2' | translate}}
            </p>
          </div>
        </section>
      </div>

      <div class="container-flex">
        <section class="">
          <h2 class="subtitle">
            {{'ProcessFruzty.ExporterSection.TitleStep3' | translate}}
          </h2>
          <div class="container-text-step">
            <h1 class="number-step">03</h1>
            <div class="separator-step"> </div>
            <p class="text-step">
              {{'ProcessFruzty.ExporterSection.TextStep3' | translate}}
            </p>
          </div>
        </section>
        <section class="">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/exporter_step_3.png" style="width: 100%" alt="flag"/>
          </figure>
        </section>
      </div>


    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>

